export const common = {
  nav: {
    home: 'Inicio',
    fleet: 'Flota',
    weddings: 'Bodas',
    about: 'Nosotros',
    contact: 'Contacto',
    policies: 'Políticas',
    cart: 'Carrito',
    vehiclesForSale: 'Vehículos en Venta'
  },
  hero: {
    title: 'Alquiler de Autos de Lujo',
    titleLocation: 'Cancún y Miami',
    subtitle: 'Renta Ferrari, Lamborghini, McLaren y Porsche para bodas, eventos y experiencias VIP. Servicio premium 24/7 con seguro completo incluido. Disponible en Cancún, Tulum, Playa del Carmen y Miami.',
    viewFleet: 'Ver Flota de Autos Exóticos',
    reserveWhatsApp: 'Reservar por WhatsApp'
  },
  home: {
    brands: {
      title: 'Marcas Premium',
      subtitle: 'de Prestigio Mundial'
    },
    featured: {
      title: 'Autos de Lujo',
      titleHighlight: 'Disponibles',
      subtitle: 'Descubre nuestra flota exclusiva de superdeportivos y SUVs de lujo para alquiler en Cancún, Tulum, Playa del Carmen y Miami',
      perDay: '/día',
      passengers: 'pasajeros',
      viewDetails: 'Ver Detalles y Precios',
      viewAll: 'Ver Toda la Flota de Autos Exóticos'
    },
    forSale: {
      title: 'Vehículos',
      titleHighlight: 'en Venta',
      subtitle: 'Selección exclusiva de vehículos premium y de colección disponibles para compra',
      forSale: 'EN VENTA',
      year: 'Año',
      moreInfo: 'MÁS INFORMACIÓN',
      viewAll: 'Ver Todos los Vehículos en Venta',
      interested: 'Hola, me interesa el'
    },
    whyChoose: {
      title: '¿Por Qué',
      titleHighlight: 'Alquilar con Nosotros',
      feature1Title: 'Flota Premium Exclusiva',
      feature1Text: 'Solo los vehículos más exclusivos y mejor mantenidos: Ferrari, Lamborghini, McLaren, Porsche',
      feature2Title: 'Seguro Completo Incluido',
      feature2Text: 'Cobertura total para tu tranquilidad durante toda la experiencia de alquiler',
      feature3Title: 'Soporte 24/7',
      feature3Text: 'Asistencia disponible en todo momento para cualquier necesidad durante tu alquiler',
      feature4Title: 'Múltiples Ubicaciones',
      feature4Text: 'Disponible en Cancún, Tulum, Playa del Carmen, Miami y más destinos exclusivos'
    },
    expansion: {
      title: 'Alquiler de Autos de Lujo',
      titleHighlight: 'Ahora en Estados Unidos',
      text1: 'Ahora entregamos en Florida — desde Miami hasta los Cayos, traemos el mismo poder, prestigio y lujo que nos hizo famosos en México.',
      text2: '¿Vuelas de Cancún a Miami? Tu experiencia no termina en el aeropuerto. Tendremos tu auto de ensueño esperándote — Ferrari, Lamborghini, McLaren, G-Wagon — todo al alcance de tu mano.',
      exploreFleet: 'Explorar Flota Completa',
      contactNow: 'Contactar Ahora'
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros',
      titleHighlight: 'Clientes',
      testimonial1: 'Una experiencia inolvidable. El Lamborghini Urus superó todas mis expectativas. Servicio impecable y atención al detalle excepcional.',
      testimonial1Name: 'Carlos Mendoza',
      testimonial1Location: 'Ciudad de México',
      testimonial2: 'Alquilé el Ferrari Roma para mi aniversario. Fue el regalo perfecto. El equipo fue muy profesional y el auto estaba en condiciones perfectas.',
      testimonial2Name: 'María González',
      testimonial2Location: 'Miami, FL',
      testimonial3: 'El McLaren 720S es una bestia. La experiencia de conducción fue increíble. Definitivamente volveré a alquilar con VIP Luxury Cars MKS.',
      testimonial3Name: 'Roberto Silva',
      testimonial3Location: 'Cancún, MX'
    },
    faq: {
      title: 'Preguntas',
      titleHighlight: 'Frecuentes',
      q1: '¿Cuánto cuesta alquilar un auto de lujo en Cancún?',
      a1: 'Los precios varían según el modelo. Desde $260 USD por 30 minutos hasta $5,200 USD por 24 horas para vehículos premium como el Ferrari Roma. Ofrecemos opciones de alquiler por 30 min, 1h, 3h, 6h, 12h y 24h.',
      q2: '¿Qué marcas de autos de lujo tienen disponibles?',
      a2: 'Contamos con Ferrari, Lamborghini, McLaren, Porsche, Mercedes-Benz G63 AMG, Range Rover y Cadillac Escalade. Todos nuestros vehículos son modelos recientes y están en perfectas condiciones.',
      q3: '¿Incluye seguro el alquiler de autos de lujo?',
      a3: 'Sí, todos nuestros alquileres incluyen seguro completo para tu tranquilidad. También ofrecemos asistencia 24/7 durante todo el período de alquiler.',
      q4: '¿Puedo alquilar un auto de lujo para mi boda?',
      a4: '¡Por supuesto! Ofrecemos paquetes especiales para bodas que incluyen el alquiler del vehículo de lujo y traslado de cortesía dentro de la zona hotelera. Ideal para hacer tu día especial aún más memorable.',
      q5: '¿En qué ciudades ofrecen el servicio de alquiler?',
      a5: 'Actualmente operamos en Cancún, Tulum, Playa del Carmen (México) y Miami, Florida (USA). Ofrecemos entrega en aeropuertos y hoteles de estas ciudades.'
    }
  },
  footer: {
    description: 'Alquiler de autos de lujo premium en Cancún y Miami. Experimenta la emoción de conducir los vehículos más exclusivos del mundo.',
    quickLinks: 'Enlaces Rápidos',
    contact: 'Contacto',
    phone: 'Teléfono',
    email: 'Correo',
    followUs: 'Síguenos',
    rights: 'Todos los derechos reservados',
    poweredBy: 'Creador de Sitios Web',
    locations: 'Ubicaciones',
    cancun: 'Cancún, Quintana Roo, México',
    miami: 'Miami, Florida, USA'
  },
  common: {
    perDay: 'por día',
    viewDetails: 'Ver Detalles',
    addToCart: 'Agregar al Carrito',
    reserveNow: 'Reservar Ahora',
    contactUs: 'Contáctanos',
    learnMore: 'Saber Más',
    bookNow: 'Reservar',
    whatsapp: 'Reservar por WhatsApp',
    days: 'Días',
    total: 'Total',
    subtotal: 'Subtotal',
    remove: 'Eliminar',
    checkout: 'Finalizar Compra',
    continueShopping: 'Seguir Comprando',
    emptyCart: 'Tu carrito está vacío',
    features: 'Características',
    specifications: 'Especificaciones',
    passengers: 'Pasajeros',
    transmission: 'Transmisión',
    fuel: 'Combustible',
    year: 'Año',
    includes: 'Incluye',
    duration: 'Duración',
    hours: 'Horas',
    forSale: 'En Venta',
    requestInfo: 'Solicitar Más Información',
    price: 'Precio',
    mileage: 'Kilometraje',
    owner: 'Dueño',
    engine: 'Motor',
    horsepower: 'Caballos de fuerza',
    negotiable: 'Precio a tratar'
  },
  fleet: {
    title: 'Nuestra Flota Exclusiva',
    subtitle: 'Elige entre los vehículos de lujo más prestigiosos del mundo',
    filterAll: 'Todos',
    filterSupercar: 'Superdeportivos',
    filterSUV: 'SUVs de Lujo',
    filterSports: 'Deportivos'
  },
  weddings: {
    title: 'Paquetes de Boda',
    subtitle: 'Haz tu día especial inolvidable con nuestros vehículos de lujo exclusivos',
    description: 'Paquete exclusivo de boda con {vehicle}. Incluye alquiler del vehículo de lujo y traslado de cortesía dentro de la zona hotelera de Cancún.',
    reserveWhatsApp: 'Reservar por WhatsApp',
    contactEmail: 'Contactar por Email'
  },
  about: {
    title: 'Sobre Sun & Speed',
    subtitle: 'Tu Experiencia Premier en Alquiler de Autos de Lujo',
    mission: 'Nuestra Misión',
    missionText: 'Proporcionar una experiencia de alquiler de autos de lujo sin igual, ofreciendo los vehículos más exclusivos del mundo con un servicio excepcional y atención al detalle.',
    vision: 'Nuestra Visión',
    visionText: 'Ser la empresa líder en alquiler de autos de lujo en México y Estados Unidos, reconocida por nuestra flota premium y servicio al cliente sobresaliente.',
    values: 'Nuestros Valores',
    excellence: 'Excelencia',
    excellenceText: 'Mantenemos los más altos estándares en mantenimiento de vehículos y servicio al cliente.',
    trust: 'Confianza',
    trustText: 'Construimos relaciones duraderas basadas en transparencia y confiabilidad.',
    passion: 'Pasión',
    passionText: 'Compartimos tu pasión por los automóviles de lujo y experiencias inolvidables.',
    whyChoose: 'Por Qué Elegirnos',
    reason1: 'Flota Premium',
    reason1Text: 'Acceso a los vehículos de lujo y exóticos más exclusivos del mundo',
    reason2: 'Servicio 24/7',
    reason2Text: 'Soporte al cliente y asistencia en carretera las 24 horas',
    reason3: 'Seguro Completo',
    reason3Text: 'Cobertura de seguro integral incluida con cada alquiler',
    reason4: 'Entrega Flexible',
    reason4Text: 'Entrega y recogida del vehículo en tu ubicación preferida'
  },
  contact: {
    title: 'Contáctanos',
    subtitle: 'Ponte en contacto con nosotros para reservas o consultas',
    name: 'Nombre Completo',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    message: 'Mensaje',
    send: 'Enviar Mensaje',
    info: 'Información de Contacto',
    location: 'Ubicación',
    locationText: 'Cancún, Quintana Roo, México',
    hours: 'Horario de Atención',
    hoursText: 'Lunes - Domingo: 8:00 AM - 10:00 PM'
  },
  policies: {
    title: 'Políticas de Alquiler',
    subtitle: 'Información importante sobre nuestros términos y condiciones de alquiler',
    requirements: 'Requisitos de Alquiler',
    req1: 'Edad mínima: 25 años',
    req2: 'Licencia de conducir válida (mínimo 2 años)',
    req3: 'Tarjeta de crédito válida a nombre del conductor',
    req4: 'Pasaporte o identificación oficial',
    req5: 'Depósito de seguridad requerido',
    insurance: 'Seguro y Cobertura',
    ins1: 'Seguro de cobertura completa incluido',
    ins2: 'Exención de daños por colisión',
    ins3: 'Protección contra robo',
    ins4: 'Responsabilidad civil',
    ins5: 'Asistencia en carretera 24/7',
    cancellation: 'Política de Cancelación',
    can1: 'Cancelación gratuita hasta 48 horas antes de la recogida',
    can2: 'Reembolso del 50% para cancelaciones 24-48 horas antes',
    can3: 'Sin reembolso para cancelaciones con menos de 24 horas',
    can4: 'Modificaciones sujetas a disponibilidad',
    terms: 'Términos y Condiciones',
    term1: 'Combustible: Devolver con el mismo nivel de combustible',
    term2: 'Kilometraje: Ilimitado dentro del área acordada',
    term3: 'Conductores adicionales: $50 USD por día',
    term4: 'Devolución tardía: Se cobra a tarifa por hora',
    term5: 'Prohibido fumar en todos los vehículos',
    term6: 'No se permiten mascotas a menos que se apruebe previamente',
    rentalPolicy: 'Política de Alquiler',
    driverRequirements: 'Requisitos del Conductor',
    minAge: 'Edad mínima: 25 años',
    validLicense: 'Licencia de conducir válida con al menos 3 años de antigüedad',
    officialId: 'Identificación oficial vigente (pasaporte o INE/IFE)',
    creditCard: 'Tarjeta de crédito a nombre del conductor principal',
    proofAddress: 'Comprobante de domicilio no mayor a 3 meses',
    securityDeposit: 'Depósito de Seguridad',
    depositInfo: 'Se requiere un depósito de seguridad reembolsable que varía según el vehículo:',
    depositRange1: 'Vehículos hasta $1,000/día: $5,000 USD',
    depositRange2: 'Vehículos de $1,000 - $1,500/día: $10,000 USD',
    depositRange3: 'Vehículos de $1,500+/día: $15,000 USD',
    depositRefund: 'El depósito se reembolsa dentro de 7-14 días hábiles después de la devolución del vehículo, sujeto a inspección y sin daños.',
    fuelPolicy: 'Combustible',
    fuelInfo: 'Todos los vehículos se entregan con el tanque lleno y deben devolverse con el tanque lleno. En caso contrario, se cobrará el combustible faltante más un cargo por servicio de $50 USD.',
    mileagePolicy: 'Kilometraje',
    mileageInfo: 'Todos nuestros alquileres incluyen kilometraje ilimitado dentro del territorio acordado (México o Estados Unidos según corresponda).',
    additionalDrivers: 'Conductores Adicionales',
    additionalDriversInfo: 'Se pueden agregar conductores adicionales por $25 USD por día. Cada conductor adicional debe cumplir con los mismos requisitos que el conductor principal y estar presente al momento de la recogida del vehículo.',
    cancellationPolicy: 'Política de Cancelación',
    customerCancellation: 'Cancelación por el Cliente',
    moreThan7Days: 'Más de 7 días antes',
    refund100: 'Reembolso del 100% del monto pagado',
    between3And7Days: 'Entre 3-7 días antes',
    refund50: 'Reembolso del 50% del monto pagado',
    lessThan3Days: 'Menos de 3 días antes',
    noRefund: 'Sin reembolso',
    reservationModifications: 'Modificaciones de Reserva',
    modificationsInfo: 'Las modificaciones de fechas están sujetas a disponibilidad y pueden incurrir en cargos adicionales:',
    firstModification: 'Primera modificación: Sin cargo (más de 48 horas antes)',
    additionalModifications: 'Modificaciones adicionales: $50 USD por cambio',
    vehicleChanges: 'Cambios de vehículo: Sujeto a diferencia de precio',
    noShow: 'No Show (No Presentarse)',
    noShowInfo: 'Si el cliente no se presenta a recoger el vehículo sin cancelación previa, no habrá reembolso del monto pagado.',
    privacyPolicy: 'Política de Privacidad',
    informationCollection: 'Recopilación de Información',
    collectionInfo: 'Recopilamos la siguiente información personal:',
    fullName: 'Nombre completo, dirección y datos de contacto',
    licenseInfo: 'Información de licencia de conducir',
    paymentInfo: 'Información de pago y facturación',
    rentalHistory: 'Historial de alquileres y preferencias',
    informationUse: 'Uso de la Información',
    useInfo: 'Utilizamos su información para:',
    processReservations: 'Procesar y gestionar sus reservas',
    communicate: 'Comunicarnos con usted sobre su alquiler',
    improveServices: 'Mejorar nuestros servicios',
    sendOffers: 'Enviar ofertas y promociones (con su consentimiento)',
    dataProtection: 'Protección de Datos',
    protectionInfo: 'Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, pérdida o alteración. Todos los datos de pago se procesan a través de pasarelas de pago seguras y encriptadas.',
    yourRights: 'Sus Derechos',
    rightsInfo: 'Usted tiene derecho a:',
    accessInfo: 'Acceder a su información personal',
    correctData: 'Solicitar corrección de datos inexactos',
    deleteData: 'Solicitar la eliminación de sus datos',
    objectProcessing: 'Oponerse al procesamiento de sus datos',
    termsAndConditions: 'Términos y Condiciones',
    lesseeResponsibility: 'Responsabilidad del Arrendatario',
    maintainVehicle: 'Mantener el vehículo en buenas condiciones',
    complyLaws: 'Cumplir con todas las leyes de tránsito',
    noDriving: 'No conducir bajo influencia de alcohol o drogas',
    noRacing: 'No participar en carreras o competencias',
    noSublet: 'No subarrendar el vehículo',
    prohibitedUse: 'Uso Prohibido',
    prohibitedInfo: 'El vehículo NO puede ser utilizado para:',
    commercialTransport: 'Transporte comercial o de pasajeros',
    towingVehicles: 'Remolcar otros vehículos',
    unpavedRoads: 'Conducción en caminos no pavimentados',
    illegalActivities: 'Actividades ilegales',
    crossingBorders: 'Cruzar fronteras internacionales sin autorización',
    damagesAndAccidents: 'Daños y Accidentes',
    accidentInfo: 'En caso de accidente o daño al vehículo:',
    notifyImmediately: 'Notificar inmediatamente a Sun & Speed (24/7)',
    policeReport: 'Obtener un reporte policial si es necesario',
    noAdmitFault: 'No admitir culpabilidad en el lugar',
    documentIncident: 'Documentar el incidente con fotos',
    completeReport: 'Completar el reporte de accidente proporcionado',
    finesAndViolations: 'Multas e Infracciones',
    finesInfo: 'El arrendatario es responsable de todas las multas, infracciones de tránsito, peajes y cargos por estacionamiento incurridos durante el período de alquiler. Se cobrará un cargo administrativo de $50 USD por cada infracción procesada.',
    vehicleReturn: 'Devolución del Vehículo',
    returnInfo: 'El vehículo debe devolverse:',
    agreedDateTime: 'En la fecha y hora acordadas',
    specifiedLocation: 'En la ubicación especificada',
    fullTank: 'Con el tanque lleno de combustible',
    sameCondition: 'En las mismas condiciones que fue entregado',
    lateReturn: 'Las devoluciones tardías se cobrarán a razón de $100 USD por hora de retraso.',
    insuranceAndWarranties: 'Seguros y Garantías',
    includedCoverage: 'Cobertura Incluida',
    coverageInfo: 'Todos nuestros alquileres incluyen:',
    liabilityInsurance: 'Seguro de responsabilidad civil ($1,000,000 USD)',
    collisionDamage: 'Seguro contra daños por colisión (CDW)',
    theftProtection: 'Protección contra robo',
    roadsideAssistance: 'Asistencia en carretera 24/7',
    deductible: 'Deducible',
    deductibleInfo: 'En caso de daño o robo, el arrendatario es responsable del deducible:',
    minorDamages: 'Daños menores: $2,500 USD',
    majorDamages: 'Daños mayores: $5,000 USD',
    totalLoss: 'Pérdida total o robo: $10,000 USD',
    optionalCoverage: 'Cobertura Adicional Opcional',
    premiumProtection: 'Protección Premium (Deducible Cero)',
    premiumInfo: 'Elimina completamente el deducible en caso de daños',
    premiumPrice: '$75 USD por día',
    tireGlass: 'Seguro de Neumáticos y Cristales',
    tireGlassInfo: 'Cubre daños a neumáticos, llantas y cristales',
    tireGlassPrice: '$25 USD por día',
    personalEffects: 'Protección de Efectos Personales',
    personalEffectsInfo: 'Cubre pérdida o robo de pertenencias personales',
    personalEffectsPrice: '$15 USD por día',
    exclusions: 'Exclusiones',
    exclusionsInfo: 'El seguro NO cubre:',
    recklessDriving: 'Daños causados por conducción imprudente o negligente',
    underInfluence: 'Daños bajo influencia de alcohol o drogas',
    unauthorizedUse: 'Uso no autorizado del vehículo',
    intentionalDamage: 'Daños intencionales',
    lostKeys: 'Pérdida de llaves o documentos',
    haveQuestions: '¿Tienes Preguntas?',
    questionsInfo: 'Nuestro equipo está disponible 24/7 para ayudarte con cualquier duda',
    contactButton: 'Contactar',
    whatsappButton: 'WhatsApp'
  },
  cart: {
    title: 'Tu Reserva',
    empty: 'Tu carrito está vacío',
    emptyText: 'Agrega vehículos a tu carrito para comenzar tu reserva',
    vehicle: 'Vehículo',
    rental: 'Período de Alquiler',
    price: 'Precio',
    actions: 'Acciones',
    summary: 'Resumen de Reserva',
    subtotal: 'Subtotal',
    tax: 'IVA (16%)',
    total: 'Total',
    checkout: 'Proceder al Pago',
    continue: 'Seguir Navegando'
  },
  checkout: {
    title: 'Completa tu Reserva',
    subtitle: 'Elige tu método de pago preferido',
    personal: 'Información Personal',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    payment: 'Método de Pago',
    card: 'Tarjeta de Crédito/Débito',
    paypal: 'PayPal',
    crypto: 'Criptomonedas',
    whatsapp: 'Reservar por WhatsApp',
    cardNumber: 'Número de Tarjeta',
    expiry: 'Fecha de Vencimiento',
    cvv: 'CVV',
    complete: 'Completar Pago',
    summary: 'Resumen del Pedido',
    cryptoNote: 'Aceptamos Bitcoin, Ethereum y USDT',
    whatsappNote: 'Completa tu reserva directamente por WhatsApp con nuestro equipo'
  },
  vehiclesForSale: {
    title: 'Vehículos en Venta',
    subtitle: 'Descubre nuestra selección exclusiva de vehículos premium disponibles para compra',
    comingSoon: 'Próximamente',
    comingSoonText: 'Pronto, esta plataforma contará con una selección curada de vehículos premium en venta, incluyendo algunas de las marcas más prestigiosas del mundo.',
    exploreRentals: 'Explora Nuestra Flota de Alquiler'
  }
};